function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFD506",
  d: "M27.917 2.5c2.44.003 4.433 1.91 4.575 4.315l.008.27v28.227c0 .557-.297 1.072-.778 1.352-.422.244-.93.276-1.373.096l-.187-.091L20 30.863 9.838 36.669c-.363.207-.788.258-1.18.152l-.194-.065-.186-.092c-.428-.249-.71-.683-.767-1.168l-.011-.184V7.084c.003-2.44 1.91-4.433 4.314-4.575l.27-.008h15.833z",
  transform: "translate(-732 -210) translate(394 160) translate(264 40) translate(74 10)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B49600",
  d: "M12.084 2.5h15.833c2.44.003 4.433 1.91 4.575 4.315l.008.27v28.227c0 .557-.297 1.072-.778 1.352-.422.244-.93.276-1.373.096l-.187-.091L20 30.863 9.838 36.669c-.363.207-.788.258-1.18.152l-.194-.065-.186-.092c-.428-.249-.71-.683-.767-1.168l-.011-.184V7.084c.003-2.44 1.91-4.433 4.314-4.575l.27-.008zm15.831 3.125h-15.83c-.749 0-1.365.564-1.45 1.29l-.01.17v25.532l8.59-4.91c.424-.243.933-.274 1.375-.092l.185.091 8.6 4.913V7.085c0-.749-.564-1.365-1.29-1.45l-.17-.01z",
  transform: "translate(-732 -210) translate(394 160) translate(264 40) translate(74 10)"
}))))));

var SvgIconSaveSecili = function SvgIconSaveSecili(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSaveSecili, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-save-secili.6d47f211.svg";
export { ForwardRef as ReactComponent };